// extracted by mini-css-extract-plugin
export default {"wrapper":"AddCompany_wrapper__WVsy2"};